(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.directive('collapsableFilter', [CollapsableFilterFn]);

    /* collapsable filter directive */
    function CollapsableFilterFn() {
        var directive = {
            link: link,
            restrict: 'E',
            transclude: true,
            templateUrl: '/app/agenda/templates/collapsable-filter.template.html',
            scope: {
                clearFn: '&',
                reloadFn: '&',
                hidefilterbuttons: '<'
            }
        };
        return directive;
        function link(scope, element, attrs) {
            // is filter collapsed or not
            scope.filterCollapsed = false;

            // collapse or expand the filter part
            scope.collapse = function () {
                scope.filterCollapsed = !scope.filterCollapsed;
            };
            
            scope.clear = function () {
                if (scope.clearFn) {
                    scope.clearFn();
                }
            };

            scope.confirm = function () {
                if (scope.reloadFn) {
                    scope.reloadFn();
                }
            };

        } // link
    }
})();